<!--
 Copyright (c) Qwoach LLC 2024. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
 Created by Artem Bogush <artem@qwoach.com> on 02/08/2024
-->

<template>
	<img v-if="iconImage"
		 ref="imgRef"
		 class="qw-icon-root"
		 :src="require(`@/assets/images/${iconImage}`)"
		 :style="{width: imageSizeComputed}"
		alt=""/>
	<i v-else
	   class="qw-icon-root"
	   :class="[icon, fontFamilyClass]"/>
</template>

<script>

import BaseComponent from "@/core/components/BaseComponent.vue";
import {iconTransitionMap} from "@/fonts/IconTransitionMap";

export default {
	name: "QwIcon",
	extends: BaseComponent,

	props: {
		icon: String,
		iconImage: String,
		iconImageWidth: String,
		fontFamilyClass: {type: String, default: "fontello"}
	},

	data() {
		return {
			imageSizeComputed: null
		}
	},

	mounted() {
		// this.recalculateIconImageWidth()
		this.imageSizeComputed = this.iconImageWidth || "1.125em"//"18px"
	},

	methods: {
		//for this to work properly, it's requried to listen to computedStyle.fontSize change which involves MutationObserver. Looks too heavy so we leave it for now.
		// recalculateIconImageWidth() {
		// 	if(this.$refs.imgRef){
		// 		let computedStyle = getComputedStyle(this.$refs.imgRef)
		// 		let fontSizeString = computedStyle.fontSize
		// 		let toEmFactor = fontSizeString.includes("em") ? 16 : 1
		// 		let fontSize = parseFloat(fontSizeString) * toEmFactor
		//
		// 		console.log("QwIcon.recalculateIconImageWidth: fontSize = ", fontSize, ", iconImage = ", this.iconImage)
		// 		this.imageSizeComputed = fontSize * 0.65 + "px"
		// 	}
		// },

	},

	computed: {
		iconTransitionComputed(){
			let iconName = this.iconImage || this.icon
			let {x, y} = iconTransitionMap[iconName] || {x: "0", y: "0"}

			return `translate(${x}, ${y})`
		},

	},
}
</script>

<style lang="scss">

img.qw-icon-root{
	transform: v-bind('iconTransitionComputed');
}
i.qw-icon-root{
	&:before{
		transform: v-bind('iconTransitionComputed');
		margin: 0;
	}
}

</style>
